export default __webpack_public_path__ + "static/media/greenMarker.a4895d63.svg";